import { ASSESSMENT_CONFIG } from '@/utils/const/products/vod-assessment';
import { Radio, Select } from 'antd';
import Styles from '../index.module.scss';
interface IProps {
  value: {
    scene: string;
    quality: string[];
  };
  onChange: Function;
}

const SceneSelect = ({ value, onChange, ...props }: IProps) => {
  const sceneChange = (e) => {
    onChange({
      scene: e.target.value,
      quality: value.quality,
    });
  };

  const qualityChange = (e) => {
    onChange({
      scene: value.scene,
      quality: e,
    });
  };

  return (
    <div className={Styles.sceneSelect}>
      <div className={Styles.itemContainer}>
        <span className={Styles.title}>
          {ASSESSMENT_CONFIG.selectors.videoScene.label}
        </span>
        <Radio.Group
          options={ASSESSMENT_CONFIG.selectors.videoScene.options}
          onChange={sceneChange}
          optionType="button"
          value={value?.scene}
        />
      </div>
      <div className={Styles.itemContainer}>
        <span className={Styles.title}>
          {ASSESSMENT_CONFIG.selectors.videoQuality.label}
        </span>
        <Select
          className={Styles.sceneSelect}
          value={value?.quality[0]}
          onChange={(e) => qualityChange([e, value.quality[1]])}
        >
          {ASSESSMENT_CONFIG.selectors.videoQuality.targetOptions.map(
            (item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            )
          )}
        </Select>
        <span style={{ padding: '0 12px' }}>VS</span>
        <Select
          className={Styles.sceneSelect}
          value={value?.quality[1]}
          onChange={(e) => qualityChange([value.quality[0], e])}
        >
          {ASSESSMENT_CONFIG.selectors.videoQuality.originOptions.map(
            (item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            )
          )}
        </Select>
      </div>
    </div>
  );
};

export default SceneSelect;
